import {
	type ClientPropertyArtDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPropertyTitle } from "web_myplann/Portfolio/Hooks/usePropertyTitle";
import { EditArtForm } from "web_myplann/Portfolio/Pages/ArtEdit/EditArtForm";
import { PropertyEditLayout } from "web_myplann/Portfolio/PortfolioShared/PropertyEditLayout";

export const EditArtPage = () => {
	const { t } = useResource();

	return (
		<PropertyEditLayout<ClientPropertyArtDetailResponseDTO>
			expectedTypes={[ClientPropertyTypeEnum.Art]}
			title={(property) =>
				t(Resources.Portfolio.EditProperty.title, {
					type: getPropertyTitle(property, t),
				})
			}
		>
			{({ property, propertyId, detailRoute }) => (
				<EditArtForm
					propertyId={propertyId}
					property={property}
					detailRoute={detailRoute}
				/>
			)}
		</PropertyEditLayout>
	);
};
